var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "mb-4" }, [
    _vm.isAuthenticated
      ? _c("div", {}, [
          _c("div", [
            _c("h6", { staticClass: "fw-bold" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("translate")("Account information")) +
                  "\n      "
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex" }, [
            _c("div", [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("translate")("Logged in as")) +
                  "\n        "
              ),
              _c("b", [_vm._v(_vm._s(_vm.student.email))]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ms-auto" }, [
              _c(
                "a",
                {
                  attrs: { href: "#", id: "logout" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.logout.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm._f("translate")("Logout")) +
                      "\n        "
                  ),
                ]
              ),
            ]),
          ]),
        ])
      : !_vm.isAuthenticated
      ? _c("div", {}, [
          _c("div", { staticClass: "d-flex align-items-baseline" }, [
            _c("h6", { staticClass: "fw-bold mb-0 d-flex" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm._f("translate")("User information")) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ms-auto" },
              [_c("Login", { ref: "login" })],
              1
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "mb-2 small text-muted" }, [
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm._f("translate")(
                    "Required to create your profile on the platform"
                  )
                ) +
                ".\n    "
            ),
          ]),
          _vm._v(" "),
          _c("div", [_c("Register")], 1),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }